import ChevronDown from '@/components/ui/icons/ChevronDown';
import { KiaPage_Pagebuilder_Blocks_Faqs } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { useState } from 'react';
import { containerVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const FaqsBlock = ({
  blockId,
  containerWidth,
  title,
  faqs,
}: KiaPage_Pagebuilder_Blocks_Faqs) => {
  if (!faqs?.length) return null;

  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const toggle = (i: number) => {
    setActiveFaq((prev) => (prev === i ? null : i));
  };

  return (
    <section id={blockId ?? undefined} className="w-full my-14 lg:my-24">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className={`w-full ${getContainerClass(containerWidth)}`}
      >
        {title && <h2 className="mb-5 lg:mb-10">{title}</h2>}

        <ul>
          {faqs.map((q, i) => {
            const isOpen = activeFaq === i;
            return (
              <li key={i} className="border-b border-neutral-300">
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => toggle(i)}
                  className="flex w-full items-center justify-between py-5 text-left"
                >
                  <h3>{q.label}</h3>
                  <ChevronDown
                    className={`w-6 min-w-6 h-6 transition-transform duration-200 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>

                <div
                  className={`
                    grid transition-all duration-500 ease-in-out
                    ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}
                  `}
                >
                  <div className="editor min-h-0 overflow-hidden">
                    <div className="pb-6">
                      <Wysiwyg>{q.content}</Wysiwyg>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </m.div>
    </section>
  );
};

export default FaqsBlock;
